import { createReducer } from '@reduxjs/toolkit'
import ActionTypes from '@constants/action_types.js'

export const initialState = {}

export const flashMessage = createReducer(initialState, builder => {
  builder
    .addCase(ActionTypes.RECEIVE_FLASH, (state, action) => receiveFlash(state, action))
    .addCase(ActionTypes.CLEAR_FLASH, (state, action) => clearFlash(state, action))
})
export default flashMessage

function receiveFlash(state, action) {
  const {
    payload: { flash, contextIdentifier },
  } = action
  const contextIdentifierString = contextIdentifier.toString()
  const existingFlash = state[contextIdentifierString] || []
  const nextArray = existingFlash.concat(flash)
  state[contextIdentifierString] = nextArray
  return state
}

function clearFlash(state, action) {
  const { payload: contextIdentifier } = action
  const contextIdentifierString = contextIdentifier.toString()
  delete state[contextIdentifierString]
  return state
}
